import { ErrorCodeMainEnum } from "@api-types/common/ErrorCodeConstants";
import { LiveStreamCodeEnum } from "./LiveStreamCodeConstant";

export enum LiveStreamFetchMode {
	Server = "server",
	Client = "client",
}

export type LiveStreamResult = {
	fetchMode?: LiveStreamFetchMode;
	url: string;
	// client mode only: dot-path to the playable url inside the provider JSON
	responsePath?: string | null;
	// client mode only: maps provider HTTP status -> internal LiveStreamCodeEnum
	errorMap?: Record<string, number> | null;
};

export type LiveStreamResponse = {
	statusCode: ErrorCodeMainEnum;
	errorCode?: LiveStreamCodeEnum;
	message?: string | null;
	response?: LiveStreamResult | null;
};
